// Format a variant "mg" value for display. If an explicit `unit` is passed
// (e.g. from product.variant_unit = "ml"), append that unit — value should be
// numeric-only in that case. If no unit is passed, fall back to auto-detect:
// return as-is if the value already ends in a known unit suffix, else "mg".
const UNIT_SUFFIXES = ["mcg", "kg", "ml", "mg", "iu", "g"]; // order matters — longer first

export function formatDose(value, unit) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  if (unit) {
    const u = String(unit).trim();
    if (!u) return raw;
    // Value might already have the unit typed in (legacy). Strip trailing
    // known units before appending the explicit one, so we don't produce
    // "10mlml" if a user typed "10ml" and later picked ML from the dropdown.
    const lower = raw.toLowerCase();
    for (const known of UNIT_SUFFIXES) {
      if (lower.endsWith(known)) {
        return `${raw.slice(0, raw.length - known.length)}${u}`;
      }
    }
    return `${raw}${u}`;
  }
  const lower = raw.toLowerCase();
  for (const u of UNIT_SUFFIXES) {
    if (lower.endsWith(u)) return raw;
  }
  return `${raw}mg`;
}
